<formly-form
	[form]="formGroup"
	[options]="formlyOptions"
	[fields]="layoutSchema"
	[model]="dataSet">
</formly-form>